module.exports = __webpack_public_path__ + "img/icon-md-menstruation.ab07dfc8.svg";